import { Partner } from '../../../partner/models/partner';
import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';

@Component({
  selector: 'app-kiosk-edit-child',
  templateUrl: './kiosk-edit-child.component.html',
  styleUrls: ['./kiosk-edit-child.component.css']
})
export class KioskEditChildComponent implements OnInit, OnChanges {

  partner: Partner;

  childName: string;

  actionInProgress: boolean;

  private _partnerFormIsValid: boolean;

  constructor(
    private partnerStateService: PartnerStateService,
    private kioskStateService: KioskStateService,
  ) {
  }

  get isSaveButtonEnabled(): boolean {
    return this._partnerFormIsValid && !this.actionInProgress;
  }

  ngOnInit() {
    this.partner = this.partnerStateService.selectedChild.clone;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.partner = this.partnerStateService.selectedChild;
  }

  cancelClick() {
    this.kioskStateService.update(KioskStateEnum.ChildManagement);
  }

  deleteClick() {
    this.actionInProgress = true;
    this.partnerStateService.removeChild(this.partner).subscribe(result => {
      if (result) {
        this.kioskStateService.update(KioskStateEnum.ChildManagement);
      }
      this.actionInProgress = false;
    });
  }

  saveClick() {
    this.actionInProgress = true;
    this.partnerStateService.updateChild(this.partner).subscribe(result => {
      if (result) {
        this.kioskStateService.update(KioskStateEnum.ChildManagement);
      }
      this.actionInProgress = false;
    });
  }

  onChildFormInvalid() {
    this._partnerFormIsValid = false;
  }

  onChildFormValid() {
    this._partnerFormIsValid = true;
  }

}
